import deliveryMan from "../assets/images/delivery-man.png";
import image1 from "../assets/images/man-wearing-smart.png";
import image02 from "../assets/images/happy-african-people 1.png";

const blogs = [
	{
		id: 1,
		image: image1,
		text1: "3 ways software engineers should use AI in their daily work",
		text2:
			"We believe deeply in driving social and economic progress across the region. We use our aat need the most support.",
	},

	{
		id: 2,
		image: deliveryMan,
		text1: "Rydgo Food and delivery as low as GH6.00",
		text2:
			"Get food delivery to your doorstep from thousands of amazing local and national restaurants",
	},
	{
		id: 2,
		image: image02,
		text1:
			"From the region for the region how Rydgo is solving regional problems",
		text2:
			"Get food delivery to your doorstep from thousands of amazing local and national restaurants",
	},
];

export default blogs;
